import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const aerialViewExample: TemplateDefinition = {
  mode: "compose",
  slug: "aerial-view-example",
  version: 1,
  title: "Aerial",
  description: "Hot spot detection",
  thumbnailUuid: BASE_ASSETS.aerialViewExample.uuid,
  assets: [BASE_ASSETS.aerialViewExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.aerialViewExample.uuid,
              extension: BASE_ASSETS.aerialViewExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Point to all hot spots." },
      },
    ],
    outputAnnotations: true,
    variables: {},
    temperature: 0,
    annotationFormat: "box",
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
